/* global axios */
import ApiClient from '../ApiClient';

class CaptainLlmConfig extends ApiClient {
  constructor() {
    super('captain/llm_config', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  update(data) {
    return axios.put(this.url, data);
  }
}

export default new CaptainLlmConfig();
